import YelpPixel from './YelpPixel';

export default YelpPixel;
